<div class="outcome-detail-container">

    <div class="outcome-detail-panel hub-custom-scrollbar">

        <div class="project-outcome-uniqueId-panel">
            @if (projectOutcome.outcome) {
            <div class="heading">
                <span style="font-weight: bold;">
                    Outcome ID:
                </span>
                <span style="font-weight: bold; color: #333">
                    {{projectOutcome.outcome.uniqueId}}
                </span>
            </div>
            }
            @if (projectOutcome.customOutcome) {
            <div class="heading">
                <span style="font-weight: bold;">
                    Custom Outcome ID:
                </span>
                <span style="font-weight: bold; color: #333">
                    {{projectOutcome.customOutcome.uniqueId}}
                </span>
            </div>
            }
        </div>

        @if ( !isStrategy) {
            <ul class="nav nav-tabs nav-tabs-bottom mb-0">
                <li class="nav-item">
                    <a href="#" (click)="setTabTo(tabs.outcomeDetails, $event)" class="nav-link"
                        [ngClass]="{active: activeTab === tabs.outcomeDetails}">Outcome Details</a>
                </li>
                <li class="nav-item">
                    <a href="#" (click)="setTabTo(tabs.linkedStrategyOutcomes, $event)" class="nav-link"
                        [ngClass]="{active: activeTab === tabs.linkedStrategyOutcomes}">Linked Strategy Outcomes</a>
                </li>
            </ul>
        }

        <div class="tab-content">
            <div class="tab-pane fade p-0"
                [ngClass]="{active: activeTab === tabs.outcomeDetails, show: activeTab === tabs.outcomeDetails}">

                <div class="metric-and-statement-panel">

                    @if (projectOutcome.isPolicyLeverageOutcome) {
                    <div class="heading">Leverage Outcome</div>
                    }

                    @if (projectOutcome.isPolicyLeverageOutcome) {
                    <div class="value record-description">
                        Policy
                    </div>
                    }

                    <div class="heading">Outcome Statement</div>

                    <div class="value record-description">
                        {{projectOutcome.statement}}
                    </div>
                </div>

                <div class="metric-values-panel">

                    <div class="bg-white" style="flex: 100%; margin-top: 20px;">

                        <!-- METRIC VALUES -->
                        <div class="active tab-pane fade show p-0" id="values">

                            <!-- VALUES -->
                            <div class="d-md-flex justify-content-between">
                                <h5 class="heading mt-2">Outcome {{isStrategy ? '' : 'Start, Progress and '}}Target
                                    Values
                                    ({{projectOutcome.targets?.length + projectOutcome.progress?.length}})</h5>

                                    <div class="btn-group" ngbDropdown>
                                    <div ngbDropdownToggle class="hub-dropdown-toggle">
                                        <b>
                                            <i class="icon-plus-circle2"></i>
                                        </b>
                                    </div>
                                    <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu
                                        aria-labelledby="dropdownBasic1">
                                        <button (click)="openAddEditTargetDialog(null)" class="dropdown-item">
                                            <i class="icon-plus-circle2"></i> Target
                                        </button>
                                        @if (!isStrategy) {
                                        <button (click)="openAddEditProgressDialog(null, false)" class="dropdown-item">
                                            <i class="icon-plus-circle2"></i> Progress
                                        </button>
                                        }
                                        @if (!isStrategy) {
                                        <button (click)="openAddEditProgressDialog(null, true)" class="dropdown-item"
                                            [disabled]="selectedOutcomeHasStart()">
                                            <i class="icon-plus-circle2"></i> Start
                                        </button>
                                        }
                                    </div>
                                </div>

                            </div>

                            <div class="table-responsive mb-2 metric-values-entries">
                                <table class="table table-columned table-xs metric-table">
                                    <thead>
                                        <tr class="font-weight-bold">
                                            <th class="text-right" width="5%">ID</th>
                                            <th class="text-right" width="20%">Value Type / Date</th>
                                            <th class="text-right">Metric Value</th>
                                            <th width="20%">Edit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Targets on Top -->
                                        @for (target of projectOutcome.targets; track $index) {
                                        <tr class="target-value">
                                            <td class="text-right">
                                                @if(target.uniqueId) {
                                                <div class="hub-unique-id-panel">
                                                    <span class="hub-unique-id">{{target.uniqueId}}</span>
                                                </div>
                                                }
                                            </td>
                                            <td class="text-right">
                                                <span class="text-success date-label">Target</span>
                                                <span class="d-block">{{target.targetDate | date:'yyyy-MM-dd'}}</span>
                                            </td>
                                            <td class="text-right">
                                                <div class="value">
                                                    {{target.targetValue | number : '0.0-20'}}
                                                    <span class="unit">
                                                        {{projectOutcome?.outcome ?
                                                        projectOutcome.outcome.outcomeUnit.name :
                                                        projectOutcome.customOutcome.unit}}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <button type="button" (click)="openAddEditTargetDialog(target)"
                                                    [disabled]="projectOutcome.outcome?.ncsInterventionId"
                                                    class="edit-value-button btn btn-outline bg-primary-300 text-primary btn-icon rounded-round legitRipple"
                                                    data-popup="tooltip" title="Edit value">
                                                    <i class="icon-pencil"></i>
                                                </button>
                                                <button type="button" (click)="deleteTarget(target)"
                                                    class="btn btn-outline bg-primary-300 text-primary btn-icon rounded-round legitRipple"
                                                    title="Delete value">
                                                    <i class="icon-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        }

                                        <!-- Then Progress -->
                                        @for (progress of projectOutcome.progress; track $index) {
                                        <tr [class]="progress.isStart ? 'start-value' : 'progress-value'">
                                            <td class="text-right">
                                                @if (progress.uniqueId) {
                                                <div class="hub-unique-id-panel">
                                                    <span class="hub-unique-id">{{progress.uniqueId}}</span>
                                                </div>
                                                }
                                            </td>
                                            <td class="text-right">
                                                @if (progress.isStart) {
                                                <span class="text-primary date-label">Start</span>
                                                }
                                                @if (!progress.isStart) {
                                                <span class="text-dark date-label">Progress</span>
                                                }
                                                <span class="d-block">
                                                    {{progress.progressDate | date:'yyyy-MM-dd'}}
                                                </span>
                                            </td>
                                            <td class="text-right">
                                                <div class="value">
                                                    {{progress.progressValue | number}}
                                                    <span class="unit">
                                                        {{projectOutcome?.outcome ?
                                                        projectOutcome.outcome.outcomeUnit.name :
                                                        projectOutcome.customOutcome.unit}}
                                                    </span>
                                                </div>
                                                <div class="attribution record-description">
                                                    {{progress.attributionLevel?.name}}
                                                </div>
                                                <div class="attribution-text record-description">
                                                    {{progress.attributionDescription}}
                                                </div>
                                            </td>
                                            <td>
                                                <button type="button"
                                                    [disabled]="projectOutcome.outcome?.ncsInterventionId"
                                                    (click)="openAddEditProgressDialog(progress, progress.isStart)"
                                                    class="edit-value-button btn btn-outline bg-primary-300 text-primary btn-icon rounded-round legitRipple"
                                                    data-popup="tooltip" title="Edit value">
                                                    <i class="icon-pencil"></i>
                                                </button>
                                                <button type="button" (click)="deleteProgress(progress)"
                                                    class="btn btn-outline bg-primary-300 text-primary btn-icon rounded-round legitRipple"
                                                    title="Delete value">
                                                    <i class="icon-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        }

                                    </tbody>
                                </table>
                            </div>

                            @if (!doDetailsExist()) {
                            <div class="alert alert-info alert-styled-left shadow-0">
                                There are no metric values defined yet.
                            </div>
                            }

                        </div>

                    </div>

                </div>


            </div>

            <div class="tab-pane fade active p-0"
                [ngClass]="{active: activeTab === tabs.linkedStrategyOutcomes, show: activeTab === tabs.linkedStrategyOutcomes}">

                <app-linked-strategy-outcomes-edit-panel [projectOutcome]="projectOutcome"></app-linked-strategy-outcomes-edit-panel>

            </div>

        </div>

    </div>

</div>
